module.exports = __webpack_public_path__ + "img/mn.a1533d2d.jpg";